<template>
  <div class="row pb5">
    <div class="col-5">
      <div class="row">
        <div class="col-4 lbl">
          <label>Entité :</label>
        </div>
        <div class="col">
          <Dropdown class="dropdown-height"
              v-model="entite"
              :options="entiteLibelles"
              optionValue="valeur"
              optionLabel="texte"
              scrollHeight="205px"
              :showClear="true"/>
        </div>
      </div>
    </div>
  </div>
  <div class="row pt5">
    <div class="col">
      <Button label="Rechercher" v-on:click="rechercher"/>
    </div>
    <div class="col" >
      <Button label="Effacer critères" v-on:click="effacerCriteres"/>
    </div>
    <div class="col" >
      <Button label="Ajouter" v-on:click="ajouter"/>
    </div>
    <div class="col">
      <Button label="Fermer" v-on:click="fermer"/>
    </div>
  </div>
</template>

<script>

export default {
  name: "CriteresRechercheGenre",
  emits: ['rechercher', 'fermer'],
  data() {
    return {
      entite: null,
      genre: null,
      entiteLibelles: [],
      genreLibelles: [],
      criteresRechercheGenre: {},
    }
  },
  beforeMount() {
    this.$store.dispatch('dossier/rechercherDefaut48HeuresAction')
        .then((res) => {
            this.assignerListe(res.data.entiteDecision);
        });
    this.entite = Number(this.$route.params.entite);
  },
  methods: {
    assignerListe(entiteDecision) {
      this.entiteLibelles = entiteDecision.entite.libelles;
    },
    rechercher() {
      let libelleRecherche = {};
      libelleRecherche.valeur = this.entite;
      libelleRecherche.enfant = {};
      libelleRecherche.enfant.texte = this.genre;
      libelleRecherche.enfant.code = 'Genre';
      this.$emit('rechercher', libelleRecherche);
    },
    rechercherGenre() {
      this.criteresRechercheGenre.entite = this.entite;
      this.$emit('rechercher', this.criteresRechercheGenre);
    },
    effacerCriteres() {
      this.entite = null;
    },
    ajouter() {
      this.$router.push({name: "ajouterGenre"});
    },
    fermer() {
      this.$emit('fermer');
    }
  },
}
</script>
